import React from "react";
import { Box, Grid, Typography } from "@mui/material";
import { StyledDataGridToolbar } from "./DataGridToolbar.style";
import ButtonGroup from "../ButtonGroup/ButtonGroup";
import DateRangeFilter from "../DateRangeFilter/DateRangeFilter";

const parentContainerStyle = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
};

const DataGridToolbar = (props) => {
  return (
    <Box>
      <Box sx={{ display: "flex", alignItems: "center", paddingTop: props.paddingTop }}>
        <Grid container justifyContent="flex-start">
          <Typography variant="h6" fontWeight="bold" sx={{ paddingBottom: "15px", paddingTop: "15px" }}>
            {props.header}
          </Typography>
        </Grid>
        <div style={parentContainerStyle}>
          <Grid>
            <StyledDataGridToolbar placeholder={props.filterPlaceholder} />
          </Grid>
          <Grid>
            <ButtonGroup buttons={props.buttonConfigs} />
          </Grid>
        </div>
      </Box>
      {props.showDateFilter ? (
        <Box style={{ width: "100%", position: "absolute", zIndex: "2" }}>
          <Grid container justifyContent="flex-end">
            <DateRangeFilter
              selectedFromDate={props.selectedFromDate}
              selectedToDate={props.selectedToDate}
              onApplyDateFilter={props.onApplyDateFilter}
              onClearFilter={props.onClearFilter}
            />
          </Grid>
        </Box>
      ) : (
        ""
      )}
    </Box>
  );
};

export default DataGridToolbar;
